import * as React from "react";
import { AutocompleteWithIcon, Box } from "../../../styles/ScanDetail";
import Container from "../../common/Container";
import ClubOpts from "../../common/ClubOpts";
import { Checkbox, AutoComplete } from "antdv5";
import { SetState, Fn } from "../../../client_types";
import { CalendarOutlined } from "@ant-design/icons";

interface IName {
  searchFeetNo: string;
  searchName: string;
  searchNumber: string;
}
interface IAutoInput {
  value: string;
  searchValue: string;
  dateInput: string;
}
interface IStorageSearchValue {
  feetNo: string;
  matchNumber: string;
  searchNumber?: string;
  searchName?: string;
}
interface IActionIDList {
  value: string;
}
interface IPageInfo {
  pageSize: number | string;
  current: number | string;
}
interface IProps {
  findName: IName;
  autoInput: IAutoInput;
  dateInput: string;
  lockInput: boolean;
  isChecked: boolean;
  newestActionID: string;
  actionIDList: IActionIDList[];
  pageInfo: IPageInfo;
  setPageInfo: SetState<IPageInfo>;
  setFindName: SetState<IName>;
  setAutoInput: SetState<IAutoInput>;
  setLock: SetState<boolean>;
  setIsChecked: SetState<boolean>;
  setSearchValue: SetState<string>;
  setStorageIsCheck: SetState<boolean | null>;
  setStorageSearchValue: SetState<IStorageSearchValue>;
  setDateInput: SetState<string | null>;
  setStorageSearchActionID: SetState<string>;
  handleEnter: (e: React.KeyboardEvent, fn: Fn) => void;
  handleSearch: Fn;
  handleAuth: Fn;
  searchData: Fn;
  preventRefreshCount: (fn: Fn, count: number) => void;
  clubList: any[] | null;
}

const FunctionBox = ({
  findName,
  setFindName,
  handleEnter,
  handleSearch,
  autoInput,
  actionIDList,
  setAutoInput,
  setLock,
  dateInput,
  lockInput,
  setIsChecked,
  preventRefreshCount,
  searchData,
  isChecked,
  handleAuth,
  setPageInfo,
  pageInfo,
  setDateInput,
  setStorageSearchActionID,
  setSearchValue,
  newestActionID,
  setStorageIsCheck,
  setStorageSearchValue,
  clubList,
}: IProps) => {
  return (
    <Container>
      <div className="functionBox">
        <div className="searchBox">
          <Box>
            <ClubOpts clubList={clubList} />
          </Box>
          <div className="inputBox">
            <input
              className="input"
              type="text"
              onChange={(e) => {
                setFindName({
                  ...findName,
                  searchNumber: e.target.value.trim(),
                });
              }}
              placeholder={"参赛编号"}
              value={findName.searchNumber}
              onKeyPress={(e) => handleEnter(e, handleSearch)}
              // disabled={lockInput || inputValue === ''}
            />
            <input
              className="input"
              type="text"
              onChange={(e) => {
                setFindName({
                  ...findName,
                  searchName: e.target.value.trim(),
                });
              }}
              placeholder={"参赛名称"}
              value={findName.searchName}
              onKeyPress={(e) => handleEnter(e, handleSearch)}
              // disabled={lockInput || inputValue === '' }
            />
            <input
              className="input"
              type="text"
              onChange={(e) => {
                setFindName({
                  ...findName,
                  searchFeetNo: e.target.value.trim(),
                });
              }}
              placeholder={"足环号"}
              value={findName.searchFeetNo}
              onKeyPress={(e) => handleEnter(e, handleSearch)}
              // disabled={lockInput || inputValue === '' }
            />
          </div>
          {localStorage.getItem("onAuth") === "true" ? (
            <AutocompleteWithIcon>
              <CalendarOutlined />
              <AutoComplete
                value={autoInput.value}
                options={actionIDList}
                onChange={(e) => {
                  setAutoInput({
                    value: e,
                    searchValue: e.split(" ")[1]
                      ? e.split(" ")[1].trim()
                      : e.trim(),
                    dateInput:
                      e.split(" ").length < 2 ? "" : e.split(" ")[0].trim(),
                  });
                  e.length > 0 ? setLock(false) : setLock(true);
                }}
                placeholder="记录编号日期"
                filterOption={(inputValue, option) =>
                  option?.value?.indexOf(inputValue) !== -1
                }
                onClick={() =>
                  autoInput.value !== ""
                    ? (setAutoInput({
                        value: "",
                        searchValue: "",
                        dateInput: dateInput,
                      }),
                      setLock(true),
                      setFindName({
                        searchFeetNo: "",
                        searchName: "",
                        searchNumber: "",
                      }))
                    : false
                }
                onKeyDown={(e) => handleEnter(e, handleSearch)}
                disabled={lockInput}
              />
            </AutocompleteWithIcon>
          ) : null}
        </div>
        <div className="btnGroup">
          <Checkbox
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
          >
            排除重复
          </Checkbox>
          <button
            onClick={(e) => {
              preventRefreshCount(searchData, 3);
              handleAuth();
              setPageInfo({
                ...pageInfo,
                current: 1,
              });
              autoInput.searchValue !== ""
                ? setSearchValue(autoInput.searchValue)
                : setSearchValue(newestActionID);
              autoInput.dateInput !== ""
                ? setDateInput(autoInput.dateInput)
                : setDateInput(localStorage.getItem("newest") || "");
              autoInput.searchValue !== ""
                ? setStorageSearchActionID(autoInput.searchValue)
                : setStorageSearchActionID(newestActionID);
            }}
            // disabled={lock || autoInput.value === ''}
          >
            搜寻
          </button>
          <button
            onClick={() => {
              handleAuth();
              setFindName({
                searchFeetNo: "",
                searchName: "",
                searchNumber: "",
              });
              setPageInfo({
                ...pageInfo,
                current: 1,
              });
              // setRank('ASC')
              // setSortText('正序')
              setAutoInput({
                value: "",
                searchValue: "",
                dateInput: "",
              });
              setSearchValue(newestActionID);
              setStorageSearchActionID(newestActionID);
              setStorageIsCheck(null);
              setStorageSearchValue({
                feetNo: "",
                matchNumber: "",
                searchNumber: "",
              });
              setIsChecked(true);
              preventRefreshCount(searchData, 3);
              setDateInput(localStorage.getItem("newest") || "");
              // setLock(true)
            }}
            // disabled={lock || searchValue === ''}
          >
            重置
          </button>
        </div>
      </div>
    </Container>
  );
};

export default FunctionBox;
